// JS
import '../../custom/js/index';

// Base SCSS
import '../../custom/scss/base.scss';
import '../../custom/scss/layout.scss';

// Components
import '../../custom/scss/components/breadcrumb/breadcrumb.scss';
import '../../custom/scss/components/hero/hero.scss';
import '../../custom/scss/components/sitemap/sitemap.scss';